import { FormNavButtonContinue } from 'platform/forms-system/src/js/components/FormNavButtons';
import PropTypes from 'prop-types';
import React from 'react';

const FinancialConfirmation = ({ goForward }) => (
  <va-alert status="info" class="vads-u-margin-y--4">
    <h1 slot="headline">
      Confirm that you don’t want to provide your household financial
      information
    </h1>
    <p>
      <strong>
        If you’re not eligible for VA healthcare based on enhanced eligibility
        status,
      </strong>{' '}
      we need your financial information to decide if you’re eligible based on
      your income.
    </p>
    <p>
      <strong>If you’re eligible based on enhanced eligibility status,</strong>{' '}
      you don’t have to share your financial information for eligibility. But if
      you don’t share this information, we may not be able to decide if you
      qualify for no copays, free medications, or travel reimbursement.
    </p>
    <FormNavButtonContinue
      goForward={goForward}
      primaryButtonText="Confirm"
      useWebComponents
      enableAnalytics
    />
  </va-alert>
);

FinancialConfirmation.propTypes = {
  goForward: PropTypes.func,
};

export default FinancialConfirmation;
